import React from 'react';
import useWindowDimensions from '../../hooks/useWindowDimensions';
import Layout from '../Layout';
import { Box } from '../UI/index';
import Map from './Map';
import Sidebar from './Sidebar';

export default function MarketSearch({ match }) {
	const { height } = useWindowDimensions();
	const innerHeight = height - 94;
	const [location, setLocation] = React.useState({
		city: 'london',
		center: {
			lat: 51.517708,
			lng: -0.107643,
		},
	});

	const handleFilterChange = (city, center) => {
		if (city === 'london') setLocation({ city, center });
		if (city === 'berlin') setLocation({ city, center });
		if (city === 'amsterdam') setLocation({ city, center });
	};

	return (
		<Layout>
			<Box display="flex" flexDirection="row" p="15px">
				<Map height={innerHeight} match={match} location={location} />
				<Sidebar height={innerHeight} handleFilterChange={handleFilterChange} />
			</Box>
		</Layout>
	);
}
